angular.module('wbDashboard').controller('PendingDocumentRequestControllerAurea', [
    '$scope', '$q', '$uibModal', '$timeout', 'User', 'Auth', 'Upload', 'Request', 'Message', 'Display',
function ($scope, $q, $uibModal, $timeout, User, Auth, Upload, Request, Message, Display) {

    $scope.forms = {};
    $scope.pageData = {
        sending: false,
    };
    //to be uploaded documents
    $scope.documents = { files: [], badFiles: [] };
    //uploaded documents
    $scope.documentRequest = { documents: [], types: []};

    //hide menu
    Display.setMenu(false);

    User.retrieveDocumentRequests();
    $scope.$watch( User.getDocumentRequests, function (dr, oldDR) {
        if (dr) {
            $scope.refreshDocs(dr);
            $scope.documentRequest = dr;

            if (oldDR === null && dr.status === 'submitted' && dr.dismissible) {
                //first load, so leave if can't do anything
                var declined = dr.types.find(t => t.status === 'declined');
                if (!declined) {
                    //$scope.leaveDocumentRequest();
                }
            }
        }
    });
    $scope.deleteUploadedDocument = function(doc) {
        if (!doc.key || doc.deleting) return;
        doc.deleting = true;
        User.deleteUploadedDocument(doc.key).catch(function (err) {
            Message.set({
                type: "danger",
                text: "There was an error deleting " + doc.name
            });
            doc.deleting = false;
            throw err;
        }).then(function (data) {
            return User.retrieveDocumentRequests(true);
        });
    };

    $scope.refreshDocs = function (dr) {
        angular.forEach(dr.documents, function(doc) {
            doc.date = moment(doc.created_at).toDate();
        });
        angular.forEach(dr.types, function(type) {
            angular.forEach(type.documents, function(doc) {
                doc.date = moment(doc.created_at).toDate();
            });
        });
    };

    $scope.clearBadFiles = function() {
        //used in before action in upload directive
        $scope.documents.badFiles.length = 0;
    };
    $scope.uploadDocs = function(type = null) {
        var responsePromise, badFiles;
        var data = {};
        if (type) {
            data.type = type;
        }

        angular.forEach($scope.documents.files, function(file) {
            if (!file.doc_type && file.doc_type !== null) {
                file.doc_type = type; //need the upload list to know so it can be filtered
            }
        });

        ({promise: responsePromise, badFiles} = User.uploadDocuments($scope.documents.files, data));

        $scope.pageData.sending = true;
        responsePromise.then(function() {

        }).finally(function() {
            $scope.documents.badFiles.push.apply($scope.documents.badFiles, badFiles);
            User.retrieveDocumentRequests(true);
            $scope.pageData.sending = false;
        });

    };
    $scope.downloadSecure = function (key, filename) {
        User.getDocumentUrl(key).then(function (response) {
            // var host = Request.defaults.host;
            // $scope.downloadUrl = host + response.data.response.url;
            $scope.downloadUrl = response.data.response.s3url;
            $scope.downloadFilename = filename;

            var modalInstance = $uibModal.open({
                templateUrl: "modal-document-request-download.tpl.html", //id of script tag in template
                scope: $scope,
                size: 'md',
                windowClass: 'confirm-modal secure-download-modal'
            });
            modalInstance.result.catch(angular.noop).finally(function() {
                $timeout(function() {
                    $scope.downloadUrl = null;
                    $scope.downloadFilename = null;
                });
            });

        });
    };

    $scope.isTypeLocked = function(type) {
        if ($scope.documentRequest.status === 'submitted' || type.status === 'approved') {
            return true;
        }
        return false;
    };
    $scope.isDocumentsMissing = function() {
        var missing = false;
        angular.forEach($scope.documentRequest.types, function(type) {
            if (type.status === 'approved') return;
            if (!type.documents.length) {
                missing = true;
            }
        });
        return missing;
    };

    $scope.showSubmitDocument = function() {
        if (
            ($scope.documentRequest.status === "submitted")
            || (!$scope.documentRequest.types.find(t=>t.status !== 'approved'))
        ) {
            return false;
        }
        return true;
    };
    $scope.submitDocumentConfirmation = function() {
        $scope.pageData.sending = true;

        var uuid = $scope.documentRequest.uuid;
        User.submitDocumentRequests(uuid).then(function() {
            Message.set({
                type: "success",
                text: "The documents have been submitted!"
            });
            return User.retrieveDocumentRequests(true);
        }).then(function() {
            angular.element("html, body").animate({scrollTop: 0}, 200);
        }).catch(function() {
            $scope.pageData.sending = false;
        }).finally(function() {
        });
    };

    $scope.leaveDocumentRequest = function() {
        //doesn't refresh after agreement, so must refresh now
        Display.setMenu(true);
        Display.setViewToMain();
        angular.element("html, body").scrollTop(0);
    };

}]);
